import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";
import Logo from './../assets/img/logo2.png';

export default function Header({back, bottom}) {

  return (
    <>
      <div style={{
        backgroundColor: '#ffffff',
        marginBottom: (!bottom) ? '0px' : `10px`
      }}>
        <Navbar color="faded" light>
          <NavbarBrand className="me-auto" href="/">
            <img alt="..." width={42} src={Logo} />
          </NavbarBrand>
        </Navbar>
      </div>
    </>
  )
}
